import { Lens } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import { useState } from 'react';

import { TextInput } from '../../../Forms';
import { Link } from '../../../Link';
import { MenuItem } from '../../../Menus';

import styles from './SelectFilter.module.scss';
import { SelectFilterProps } from './SelectFilter.types';

export const SelectFilter = <TData, TValue>({
  column,
  filterValue,
  setFilterValue,
  emptyItems,
}: SelectFilterProps<TData, TValue>) => {
  const [searchValue, setSearchValue] = useState('');

  const newLocal = [...column.getFacetedUniqueValues().keys()].slice(0, 5000).sort();

  const filteredItems = newLocal.filter((item: string | number | undefined) =>
    item?.toString().trim().toLowerCase().includes(searchValue.trim().toLowerCase())
  );

  return (
    <>
      <div className={styles.buttons}>
        <Link size="xsmall" onClick={() => setFilterValue(newLocal)}>
          tout sélectionner
        </Link>
        <Link size="xsmall" onClick={() => setFilterValue(undefined)}>
          effacer
        </Link>
      </div>
      <TextInput
        size="medium"
        containerClassName={styles.inputContainer}
        placeholder="votre recherche"
        leftIcon={<Lens />}
        value={searchValue}
        onValueChange={setSearchValue}
      />
      <div className={styles.items}>
        {filteredItems.map((item, index) => (
          <MenuItem
            key={`item-${index}-${item}`}
            keepOpenOnClick
            selected={filterValue?.includes(item)}
            onClick={() => {
              setFilterValue((filterValue: (string | number)[] | undefined) => {
                if (!filterValue) return [item];
                if (!filterValue.includes(item)) return [...filterValue, item];
                if (filterValue.length === 1) return undefined;
                else return filterValue.filter(v => v !== item);
              });
            }}
          >
            {item}
          </MenuItem>
        ))}
        {filteredItems.length === 0 && <p className={styles.empty}>{emptyItems}</p>}
      </div>
    </>
  );
};
